import { APIProvider, Map, MapProps } from "@vis.gl/react-google-maps";
import { ReactNode } from "react";
import TerraDrawButtons, { TerraDrawButtonProps } from "./TerraDrawButtons";

interface GoogleMapProps {
  mapProps?: MapProps;
  defaultCenter?: MapProps["defaultCenter"];
  enableTerraCtrl?: boolean;
  children?: ReactNode;
  onChange: TerraDrawButtonProps["onChange"];
  defaultPolygon?: TerraDrawButtonProps["defaultPolygon"];
  onDrawingStateChange?: TerraDrawButtonProps["onDrawingStateChange"];
  clearRequestKey?: TerraDrawButtonProps["clearRequestKey"];
}

const GoogleMap = ({
  mapProps,
  defaultCenter,
  onChange,
  defaultPolygon,
  onDrawingStateChange,
  clearRequestKey,
  enableTerraCtrl = true,
  children,
}: GoogleMapProps) => (
  <APIProvider apiKey={process.env.GOOGLE_MAPS_API_KEY || ""}>
    <Map
      defaultCenter={defaultCenter ?? { lat: 48.45, lng: -122.29 }}
      defaultZoom={12}
      fullscreenControl={false}
      {...mapProps}
    >
      {enableTerraCtrl && (
        <TerraDrawButtons
          onChange={onChange}
          defaultPolygon={defaultPolygon}
          onDrawingStateChange={onDrawingStateChange}
          clearRequestKey={clearRequestKey}
        />
      )}
      {children}
    </Map>
  </APIProvider>
);

export default GoogleMap;
